var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterIconBlue = function SvgFilterIconBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0265dc",
    d: "M7.775 10.91a.57.57 0 0 1 .184.41V20l4.082-3.187V11.32c0-.155.068-.298.184-.41l6.904-6.871H.871zM20 0H0v2.796h20z"
  })));
};
export { SvgFilterIconBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNzc1NDkgMTAuOTEwMkM3Ljg5MTE0IDExLjAyMiA3Ljk1OTE2IDExLjE2NSA3Ljk1OTE2IDExLjMyMDNWMjBMMTIuMDQwOCAxNi44MTI3VjExLjMyMDNDMTIuMDQwOCAxMS4xNjUgMTIuMTA4OCAxMS4wMjIgMTIuMjI0NSAxMC45MTAyTDE5LjEyOTIgNC4wMzg1MUgwLjg3MDcyOEw3Ljc3NTQ5IDEwLjkxMDJaIiBmaWxsPSIjMDI2NWRjIi8+CjxwYXRoIGQ9Ik0yMCAwSDBWMi43OTU5SDIwVjBaIiBmaWxsPSIjMDI2NWRjIi8+Cjwvc3ZnPgo=";